import { useNavigate } from "react-router-dom";

interface ErrorStateProps {
  message: string;
}

export const ErrorState = ({ message }: ErrorStateProps) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h2 className="text-xl font-semibold">Survey Unavailable</h2>
        <p className="text-muted-foreground mt-2">{message}</p>
        <button 
          onClick={() => navigate("/")}
          className="mt-4 px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90"
        >
          Return Home
        </button>
      </div>
    </div>
  );
};